import { AddButton } from '../../styledComponents/GlobalStyle';
import { connect } from 'react-redux';
import Select from 'react-select';
import { useState, useMemo } from 'react';
import { Actions as USAGEACTIONS } from '../../store/actions/usageActions';

const BulkCopyModal = ({ modal, setModal, facilities, usageData, copyUsageData }) => {
  const [showFacility, setShowFacility] = useState(false);
  const [showCustomLabel, setShowCustomLabel] = useState(false);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [customLabel, setCustomLabel] = useState('');

  const facilityOptions = facilities?.map((facility) => ({
    value: facility.id,
    label: facility.name,
  }));

  const checkedUsages = useMemo(() => usageData?.filter((usage) => usage.checked), [usageData]);

  return (
    <div className='modal' style={{ display: 'block', background: 'rgba(0,0,0,.5)' }}>
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h4 className='modal-title'>Bulk Copy Usage Data</h4>
            <button className='modal-close' onClick={() => setModal(false)}>
              <i className='fa fa-times' />
            </button>
          </div>
          <div className='modal-body'>
            <span>Do you want to change some fields from the usage data?</span>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: 10 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type='checkbox'
                  id='facility-checkbox'
                  checked={showFacility}
                  onChange={(e) => setShowFacility(e.target.checked)}
                />
                <label htmlFor='facility-checkbox' style={{ fontWeight: '550', marginBottom: 0, cursor: 'pointer' }}>
                  Change Facility
                </label>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                  type='checkbox'
                  id='label-checkbox'
                  checked={showCustomLabel}
                  onChange={(e) => setShowCustomLabel(e.target.checked)}
                />
                <label htmlFor='label-checkbox' style={{ fontWeight: '550', marginBottom: 0, cursor: 'pointer' }}>
                  Change Custom Label
                </label>
              </div>

              {showFacility && (
                <div>
                  <label style={{ fontWeight: '550', marginBottom: 0 }}>Facility</label>
                  <Select
                    isClearable={true}
                    options={facilityOptions}
                    value={facilityOptions.find((option) => option.value === selectedFacility)}
                    onChange={(e) => setSelectedFacility(e?.value)}
                  />
                </div>
              )}

              {showCustomLabel && (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontWeight: '550', marginBottom: 0 }}>Custom Label</label>
                  <input
                    className='form-control'
                    type='text'
                    placeholder='Enter custom label'
                    value={customLabel}
                    onChange={(e) => setCustomLabel(e.target.value)}
                  />
                </div>
              )}
            </div>
          </div>
          <div className='modal-footer' style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
            <AddButton
              disabled={showFacility && !selectedFacility}
              id='copy-usage-data-button'
              onClick={() => {
                copyUsageData(checkedUsages, {
                  facility: selectedFacility,
                  label: customLabel,
                });
                setModal(false);
              }}>
              Copy {checkedUsages.length} Usage Data
            </AddButton>
            <button
              type='button'
              className='btn btn-secondary'
              style={{ border: '1px solid #ccc', fontWeight: '550' }}
              onClick={() => setModal(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    usageData: state.usageData || [],
    facilities: state.facility?.list || [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    copyUsageData: (usageData, changes) => dispatch(USAGEACTIONS.copyUsageData(usageData, changes)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkCopyModal);
